/* ════════════════════════════════════════════════════════════
   kp-reveal.js — Scroll reveal + terminal activation
   Vanilla JS, ES2018+, no dependencies.

   1. IntersectionObserver que agrega .is-in a cada .kp-reveal
      cuando el elemento entra en viewport.
   2. Respeta prefers-reduced-motion: si está activo, activa todos
      de inmediato sin observer.
   3. Observer secundario para [data-animate="true"] (terminal):
      agrega kp-terminal--active cuando entra en viewport.
   ════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var REVEAL_CLASS = 'kp-reveal';
  var ACTIVE_CLASS = 'is-in';
  var TERMINAL_ATTR = '[data-animate="true"]';
  var TERMINAL_ACTIVE = 'kp-terminal--active';

  var OBSERVER_OPTIONS = {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
  };

  function activateAll(elements) {
    Array.prototype.forEach.call(elements, function (el) {
      el.classList.add(ACTIVE_CLASS);
    });
  }

  function activateTerminals(elements) {
    Array.prototype.forEach.call(elements, function (el) {
      el.classList.add(TERMINAL_ACTIVE);
    });
  }

  function init() {
    var revealEls = document.querySelectorAll('.' + REVEAL_CLASS);
    var terminalEls = document.querySelectorAll(TERMINAL_ATTR);

    // Si el usuario prefiere reducir movimiento, activar todo de inmediato.
    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      activateAll(revealEls);
      activateTerminals(terminalEls);
      return;
    }

    // Observer principal: .kp-reveal → agrega .is-in
    if (revealEls.length > 0 && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(ACTIVE_CLASS);
            revealObserver.unobserve(entry.target);
          }
        });
      }, OBSERVER_OPTIONS);

      Array.prototype.forEach.call(revealEls, function (el) {
        revealObserver.observe(el);
      });
    } else {
      // Fallback: sin IntersectionObserver, activar todo.
      activateAll(revealEls);
    }

    // Observer secundario: [data-animate="true"] → agrega kp-terminal--active
    if (terminalEls.length > 0 && 'IntersectionObserver' in window) {
      var terminalObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(TERMINAL_ACTIVE);
            terminalObserver.unobserve(entry.target);
          }
        });
      }, OBSERVER_OPTIONS);

      Array.prototype.forEach.call(terminalEls, function (el) {
        terminalObserver.observe(el);
      });
    } else {
      activateTerminals(terminalEls);
    }
  }

  // Ejecutar cuando el DOM esté listo.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
